/**
 * MegaMenu Module
 */

import Axios from 'axios'

const state = {
  /**
   * mega menü
   */
  menu: [],
  /**
   * be van-e töltve a menu
   */
  isMenuLoadDone: false,
  /**
   * töltődik-e a menu
   */
  isMenuLoading: false,
}

const getters = {
  /**
   * menu getter
   *
   * @param state
   * @returns {null}
   */
  getMenu: state => {
    return state.menu
  },
  /**
   * be van-e töltve a menu
   *
   * @param state
   * @returns {null}
   */
  isMenuLoadDone: state => {
    return state.isMenuLoadDone
  },
  /**
   * töltődik-e a menu
   *
   * @param state
   * @returns {null}
   */
  isMenuLoading: state => {
    return state.isMenuLoading
  },
}

const actions = {
  init({ dispatch }) {
    return Promise.all([
      dispatch('loadMenu'),
    ])
  },
  /**
   * mega menu betöltése
   *
   * @param commit
   * @return {Promise<AxiosResponse<any>>}
   */
  loadMenu({ commit, dispatch }) {
    commit('setIsMenuLoading', true)
    dispatch('loadMenuSkeleton')
      .then(() => {
        return Axios.get('MegaMenu/api/getMegaMenu')
          .then(({ data }) => {
            commit('setMenu', data)
          })
          .catch((error) => {
            commit('setMenu', null)
            console.error(error)
          })
          .finally(() => {
            commit('setIsMenuLoading', false)
            commit('setIsMenuLoadDone', true)
          })
      })
  },
  /**
   * mega menu skeleton betöltése
   *
   * @param commit
   * @return {Promise<AxiosResponse<any>>}
   */
  loadMenuSkeleton({ commit }) {
    return Axios.get('MegaMenu/api/getMegaMenuSkeleton')
      .then(({ data }) => {
        commit('setMenu', data)
      })
      .catch((error) => {
        commit('setMenu', null)
        console.error(error)
      })
  },
}

const mutations = {
  /**
   * @param state
   * @param payload
   */
  setMenu(state, payload) {
    state.menu = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsMenuLoadDone(state, payload) {
    state.isMenuLoadDone = payload
  },
  /**
   * @param state
   * @param payload
   */
  setIsMenuLoading(state, payload) {
    state.isMenuLoading = payload
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
